export const DOMAIN_TYPE = {
  WEB: 'web',
  DESKTOP: 'desktop',
} as const;

export const MACHINE_TYPE = {
  WEB: 'WEB',
  FAKE_DESKTOP: 'FAKE_DESKTOP',
  DESKTOP: 'DESKTOP',
} as const;

export const LOCAL_STORAGE_MACHINE_TYPE_KEY = 'MACHINE_TYPE';
